<template>
  <div
    class="container"
    :class="containerClasses"
  >
    <StSidebar
      :minimize="windowWidth < 1488"
      @sidebar-changed="sideBarChanged"
    >
      <template
        v-if="expandContainer"
        #items
      >
        <SidebarItemList :is-sidebar-mini="isSidebarMini" />
      </template>
    </StSidebar>
    <ContainerHeader />
    <v-row
      class="layout-content no-gutters"
    >
      <transition name="fade">
        <router-view :is-brands-fetched="isFetchingOk" />
      </transition>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import StSidebar from '@stilingue/st-sidebar';
import SidebarItemList from './base/SidebarItemList';
import ContainerHeader from '@/components/fast_intelligence/BrandHeader/ContainerHeader.vue';

export default {
  name: 'LayoutContent',
  components: {
    StSidebar,
    SidebarItemList,
    ContainerHeader,
  },
  data() {
    return {
      isFetchingOk: false,
      isSidebarMini: false,
      expandContainer: true,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    containerClasses() {
      return {
        'container--expanded': this.expandContainer
      };
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  async created() {
    this.isFetchingOk = await this.fetchMonitoredBrands();
    await this.handleUrlParams(this.$route.query);
  },
  methods: {
    ...mapActions('fastIntelligence', ['fetchMonitoredBrands']),
    ...mapActions('filter', ['handleUrlParams']),
    sideBarChanged({ mini }) {
      this.expandContainer = !mini;
    }
  },
};
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease-in-out;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .container {
    width: 100vw;
    max-width: 100vw;
    padding: 0 0 0 68px;
    margin: 0;
    -webkit-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    -moz-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .container--expanded {
    padding-left: 223px;
  }

  .layout-content {
    overflow: auto;
  }
</style>
